import { apiClient } from "../api/apiClient";

const getDiscountCodes = (eventId) =>
    apiClient.get(`/events/${eventId}/discount-codes`, { requiresAuth: true });

const createDiscountCode = (eventId, discountCode) =>
    apiClient.post(`/events/${eventId}/discount-codes`, discountCode, { requiresAuth: true });

const updateDiscountCode = (eventId, id, discountCode) =>
    apiClient.put(`/events/${eventId}/discount-codes/${id}`, discountCode, { requiresAuth: true });

const deleteDiscountCode = (eventId, id) =>
    apiClient.delete(`/events/${eventId}/discount-codes/${id}`, { requiresAuth: true });

export default {
    getDiscountCodes,
    createDiscountCode,
    updateDiscountCode,
    deleteDiscountCode,
};
